export default class HitActionItem {
  // méthode constructor
  constructor(
    id,
    label,
    icon,
    {
      buttonColor = 'button-floating',
      active = true,
      hideLabelOnLgLayout = false,
      subActions = [],
      spinner = false,
      tooltip = null,
      splitButton = false,
    } = {}
  ) {
    this.id = id;
    this.label = label;
    this.icon = icon;
    this.buttonColor = buttonColor;
    this.disabled = active === false;
    this.spinner = spinner;
    this.tooltip = tooltip;
    this.hideLabelOnLgLayout = hideLabelOnLgLayout;
    this.subActions = subActions;
    this.splitButton = splitButton;
  }
}
